import { initAccordion } from '../../components/accordion';

// /account/register?view=referral
export default class CustomerReferral {
  referral_account_path;
  elements;

  constructor() {
    this.referral_account_path = '/pages/referral-account';

    this.elements = {
      section: document.querySelectorAll('.customer-referral-section'),
      formTabs: document.querySelectorAll('.customer-referral__tab'),
      registrationButton: document.querySelector('.customer-referral__register [type="button"]'),
      loginButton: document.querySelector('.customer-referral__login [type="button"]'),
    };

    if (!this.elements.section.length) {
      return;
    }

    if (window.theme.isLoggedIn === true) {
      window.location.href = this.referral_account_path;
      return;
    }

    // Reset local storage items (gets a value when submitting the form)
    window.localStorage.setItem('referral-registration', '');
    window.localStorage.setItem('referral-recover', '');
    window.localStorage.setItem('referral-login', '');

    // Listeners
    if (this.elements.formTabs.length) {
      // this.elements.formTabs.addEventListener('click', this.changeTab.bind(this));
      Array.from(this.elements.formTabs).forEach((element) => {
        element.addEventListener('click', this.changeTab.bind(this));
      });
    }

    if (this.elements.registrationButton !== null) {
      this.elements.registrationButton.addEventListener('click', this.handleRegistration.bind(this));
    }
    
    if (this.elements.loginButton !== null) {
      this.elements.loginButton.addEventListener('click', this.handleLogin.bind(this));
    }

    // Handle error messages
    this.handleErrors();

    // Select the correct tab based on page url
    this.changeTab();

    // Initialize the FAQ accordion
    this.initFAQ();
  }

  handleErrors = () => {
    // Errors collected on regular registration page
    const referral_registration_errors = window.localStorage.getItem('referral-registration-errors') || '';
    const registration_form = document.getElementById('create_customer');
    if (registration_form && referral_registration_errors !== '') {
      const element = document.createElement('ul');
      element.classList.add('errors');
      element.innerHTML = referral_registration_errors;
      registration_form.parentNode.insertBefore(element, registration_form);
      window.localStorage.setItem('referral-registration-errors', '');
    }

    // Errors/success collected on regular login page
    const login_form = document.querySelector('.customer-referral__login #customer_login');
    const referral_login_errors = window.localStorage.getItem('referral-login-errors') || '';
    if (login_form && referral_login_errors !== '') {
      // Careful, we can have multiple sign in form on the page (sign in modal)
      const element = document.createElement('ul');
      element.classList.add('errors');
      element.innerHTML = referral_login_errors;
      login_form.parentNode.insertBefore(element, login_form);
      window.localStorage.setItem('referral-login-errors', '');
    }
    /*
    // Keeping these. We don't need them right now as we're using the original recovery pages
    const referral_recover_errors = window.localStorage.getItem('referral-recover-errors') || '';
    if (referral_recover_errors !== '') {
      $('#RecoverPasswordForm').prepend(`<div class="errors">${referral_recover_errors}</div>`);
      window.localStorage.setItem('referral-recover-errors', '');
    }
  
    const referral_recover_success = window.localStorage.getItem('referral-recover-success') || '';
    if (referral_recover_success !== '') {
      $('#ResetSuccess').html(referral_recover_success).removeClass('hide');
      window.localStorage.setItem('referral-recover-success', '');
    }
    */
  };

  initFAQ = () => {
    if (!document.querySelectorAll('.customer-referral__faq').length) {
      return;
    }
    
    initAccordion('#CustomerReferralFAQ');
  };
  
  changeTab = (e) => {
    // We only use 1 template
    // Example: /account/register?view=referral&form=login
    let show_form = (window.location.search.includes('form=login')) ? 'login' : 'register';
    let hide_form = (window.location.search.includes('form=login')) ? 'register' : 'login';
    
    if (typeof e !== 'undefined') {
      show_form = (e.currentTarget.dataset.referralTabType === 'login') ? 'login' : 'register';
      hide_form = (e.currentTarget.dataset.referralTabType === 'login') ? 'register' : 'login';
    }

    // Array.from(document.querySelectorAll('.customer-referral__forms .form')).forEach((element) => element.classList.remove('active'));
    // document.querySelector(`[data-customer-referral-${show_form}]`).classList.add('active');
    document.querySelector(`[data-referral-tab-type="${show_form}"]`).removeAttribute('tabindex');
    document.querySelector(`[data-referral-tab-type="${show_form}"]`).classList.add('active');
    document.querySelector(`[data-referral-tab-type="${hide_form}"]`).setAttribute('tabindex', '-1');
    document.querySelector(`[data-referral-tab-type="${hide_form}"]`).classList.remove('active');
    document.querySelector(`[data-form-${show_form}]`).classList.remove('visually-hidden');
    document.querySelector(`[data-form-${hide_form}]`).classList.add('visually-hidden');
  };

  handleRegistration = (e) => {
    // const item = e.currentTarget;
    window.localStorage.setItem('referral-registration', Date.now());
    const form = document.getElementById('create_customer');

    if (form.parentNode.querySelector('.errors')) {
      form.parentNode.querySelector('.errors').remove();
    }

    if (!document.getElementById('FirstName').value.length || !document.getElementById('LastName').value.length || !document.getElementById('Email').value.length || !document.getElementById('CreatePassword').value.length) {
      const element = document.createElement('div');
      element.classList.add('errors');
      element.textContent = 'Please fill out all the fields';
      form.parentNode.insertBefore(element, form);

      return;
    }

    form.submit();
  };

  handleLogin = (e) => {
    window.localStorage.setItem('referral-login', Date.now());

    // Careful, we can have multiple sign in form on the page (sign in modal)
    // const form = document.getElementById('customer_login');
    const form = document.querySelector('.customer-referral__login #customer_login');

    if (form.parentNode.querySelector('.errors')) {
      form.parentNode.querySelector('.errors').remove();
    }

    if (!document.getElementById('CustomerEmail').value.length || !document.getElementById('CustomerPassword').value.length) {
      const element = document.createElement('div');
      element.classList.add('errors');
      element.textContent = 'Please fill out all the fields';
      form.parentNode.insertBefore(element, form);

      return;
    }

    form.submit();
  };
}
